import React, { useEffect } from 'react';

function ClickaduAd() {
    useEffect(() => {
        const script = document.createElement("script");
        script.setAttribute("data-cfasync", "false");
        script.setAttribute("type", "text/javascript");
        script.setAttribute("src", "//hhbypdoecp.com/lv/esnk/1978451/code.js");
        script.async = true;
        script.id = "__clb-1978451";
      
        document.getElementById("clickadu-wrapper").appendChild(script);
      
        if (window.clickadu_creativ) {
          window.clickadu_creativ({
            slot: '1978451',
            container: 'clickadu-container',
            width: 300,
            height: 100,
          });
        }
      }, []);
      
  
    return (
      <div id="clickadu-wrapper">
        <div id="clickadu-container"></div>
      </div>
    );
  }
  
export default ClickaduAd;
